const encoder = new TextEncoder();

const bytesToHex = (bytes) =>
  [...bytes].map((value) => value.toString(16).padStart(2, "0")).join("");

export const sha256Text = async (value) => {
  if (!globalThis.crypto?.subtle) return "";
  const digest = await globalThis.crypto.subtle.digest(
    "SHA-256",
    encoder.encode(String(value ?? "")),
  );
  return bytesToHex(new Uint8Array(digest));
};

export const translationKey = (taskId, criterionId, sourceHash) =>
  `${String(taskId || "").trim()}::${String(criterionId || "").trim()}::${String(sourceHash || "").trim().toLowerCase()}`;

const normalizeTranslation = (item) => {
  if (!item || typeof item !== "object") return null;
  const taskId = String(item.task_id || item.taskId || "").trim();
  const criterionId = String(item.criterion_id || item.criterionId || "").trim();
  const sourceHash = String(item.source_hash || item.sourceHash || "").trim().toLowerCase();
  const zh = String(item.zh || item.translation_zh || "").trim();
  const en = String(item.en || item.translation_en || "").trim();
  if (!taskId || !criterionId || !sourceHash || (!zh && !en)) return null;
  return { taskId, criterionId, sourceHash, zh, en };
};

export const parseBilingualSidecars = (entries = []) => {
  const translations = new Map();
  const errors = [];
  let files = 0;
  for (const entry of entries) {
    const path = String(entry?.path || "");
    if (!entry?.text || !/(?:bilingual|translation).*\.json$/i.test(path)) continue;
    let payload;
    try {
      payload = JSON.parse(entry.text);
    } catch (error) {
      errors.push(`${path}: ${error instanceof Error ? error.message : String(error)}`);
      continue;
    }
    const raw = Array.isArray(payload)
      ? payload
      : payload?.criterion_translations || payload?.translations;
    if (!Array.isArray(raw)) continue;
    files += 1;
    for (const source of raw) {
      const item = normalizeTranslation(source);
      if (!item) {
        errors.push(`${path}: invalid criterion translation record`);
        continue;
      }
      translations.set(translationKey(item.taskId, item.criterionId, item.sourceHash), item);
    }
  }
  return { translations, errors, files };
};

export const bindCriterionTranslations = async (taskId, criteria, sidecar) =>
  Promise.all((criteria || []).map(async (criterion) => {
    const description = String(criterion.description || "");
    const sourceHash = description ? await sha256Text(description) : "";
    const translation = sourceHash
      ? sidecar?.translations?.get(translationKey(taskId, criterion.id, sourceHash)) || null
      : null;
    return { ...criterion, sourceHash, translation };
  }));

export const criterionDescription = (criterion, locale) => {
  if (locale === "zh" && criterion?.translation?.zh) return criterion.translation.zh;
  if (locale === "en" && criterion?.translation?.en) return criterion.translation.en;
  return criterion?.description || "";
};
